import { styled } from 'parkdepot-shared/theme'

export const TitleContainer = styled<'div', { $opened?: boolean }>('div', ({ $theme, $opened = false }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: $opened ? '2.4rem 1.6rem 1rem' : '2.4rem 1.6rem'
}))

export const Title = styled('span', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    fontWeight: 700
}))

export const ToggleIcon = styled('i', ({ $theme }) => ({
    fontSize: '1.6rem'
}))
